//
import GBranchOfficeModel from '@/models/General/GBranchOffice'
import GUserModel from '@/models/General/GUser'

//
export default [
  {
    name: 'g_branch_office_id',
    type: 'autocomplete-model',
    props: {
      label: 'Sucursal',
      model: GBranchOfficeModel,
      itemText: 'name',
      itemValue: 'id',
      noObject: true,
      paramSearch: 'name',
    },
  },
  {
    name: 'g_user_id',
    type: 'autocomplete-model',
    props: {
      label: 'Responsable',
      model: GUserModel,
      itemText: 'hr_employee.name_case',
      itemValue: 'id',
      noObject: true,
    },
  },
  {
    name: 'code',
    type: 'text-field',
    props: {
      label: 'Código',
    },
  },
]
